// extracted by mini-css-extract-plugin
export var createdDate = "_h8-1";
export var divider = "_h8-2";
export var headerDivider = "_h8-3";
export var messagesCard = "_h8-0";
export var messagesContainer = "_h8-7";
export var messagesContainerWrapper = "_h8-4";
export var pointerCapturingButtonBoxes = "_h8-a";
export var showLeftPanelButton = "_h8-9";
export var showMoreButton = "_h8-c";
export var showMoreButtonContainer = "_h8-b";
export var summaryTitle = "_h8-6";
export var systemMessageCardWrapper = "_h8-d";
export var topButtons = "_h8-8";
export var withPadding = "_h8-5";